/**
 * Intelligent Route Prefetching for VEXL Nova Documentation
 * Preloads page chunk bundles in browser idle time on link hover/focus.
 */

const docsRouteLoaders: Record<string, () => Promise<unknown>> = {
  '/nova/docs/getting-started': () => import('../pages/NovaGettingStarted'),
  '/nova/docs/spatial-data': () => import('../pages/NovaSpatialDataDocs'),
  '/nova/docs/prompt-guide': () => import('../pages/NovaPromptGuide'),
  '/nova/docs/memory': () => import('../pages/NovaDocsMemory'),
  '/nova/docs/changelog': () => import('../pages/NovaDocsChangelog'),
  '/nova/docs/faq': () => import('../pages/NovaFAQ'),
  '/nova/docs/troubleshooting': () => import('../pages/NovaTroubleshooting'),
  '/nova/docs/tools': () => import('../pages/NovaToolLibrary'),
  '/nova/docs/managing-chats': () => import('../pages/NovaDocsManagingChats'),
  '/nova/docs/temporary-chats': () => import('../pages/NovaDocsTemporaryChats'),
  '/nova/docs/arcpy-execution': () => import('../pages/NovaArcPyExecutionDocs'),
  '/nova/docs/deep-research': () => import('../pages/NovaDeepResearchDocs'),
  '/nova/docs/spatial-files': () => import('../pages/NovaSpatialFilesDocs'),
  '/nova/docs/docx-generator': () => import('../pages/NovaAcademicDocxDocs'),
  '/nova/docs/desktop-integration': () => import('../pages/NovaDesktopIntegrationDocs'),
};

const prefetchedRoutes = new Set<string>();

export const prefetchDocRoute = (href: string): void => {
  if (prefetchedRoutes.has(href)) return;
  const loader = docsRouteLoaders[href];
  if (!loader) return;

  prefetchedRoutes.add(href);

  // Prefetch asynchronously in browser idle time
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    (window as Window & { requestIdleCallback: (cb: () => void) => void }).requestIdleCallback(() => {
      loader().catch(() => prefetchedRoutes.delete(href));
    });
  } else {
    setTimeout(() => {
      loader().catch(() => prefetchedRoutes.delete(href));
    }, 0);
  }
};
